import React, { useEffect } from 'react';
import { ListGroupItem } from 'shards-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faSpinner } from '@fortawesome/free-solid-svg-icons';
import useFileDownload from '../../hooks/download/useFileDownload';
import type { IconDefinition } from '@fortawesome/free-solid-svg-icons';

interface DownloadItemProps {
  displayName: string;
  path: string;
  fileName: string;
  icon?: IconDefinition;
  iconClassName?: string;
  setErrorMessage: React.Dispatch<React.SetStateAction<string>>;
}

const DownloadItem = ({ displayName, path, fileName, icon = faFile, iconClassName = '', setErrorMessage }: DownloadItemProps): React.ReactElement => {
  const cursorStyle = { cursor: 'pointer' };
  const { download, isDownloading, message } = useFileDownload();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    // console.log(message);
    setErrorMessage(message);
  }, [message]);

  // EVENT HANDLER
  // ================================================================================

  const handleDownload = (): void => {
    download(path, fileName);
  };

  // VIEW
  // ================================================================================

  return (
    <>
      <ListGroupItem className="d-flex px-3" onClick={handleDownload}>
        <a className="download-link" style={cursorStyle}>
          <FontAwesomeIcon icon={icon} className={iconClassName} size={'lg'} />
          <span className="mx-2 text-semibold text-fiord-blue">{displayName}</span>
          {isDownloading && <FontAwesomeIcon icon={faSpinner} spin={true} />}
        </a>
      </ListGroupItem>
    </>
  );
};

export default DownloadItem;
